import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { RegisterComponent } from './register';
import { VerifyComponent } from './verify/verify.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { ResetPasswordConfirmComponent } from './login/reset-password-confirm/reset-password-confirm.component';
import { AuthGuard } from './_guards';
import { MyAccountComponent } from './my-account/my-account.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SsoComponent } from './sso/sso.component';
import { LoginByTokenComponent } from './login-by-token/login-by-token.component';
import { DependentComponent } from './dependent/dependent.component';
import { RegisterDependentComponent } from './register/register-dependent/register-dependent.component';

const routes: Routes = [
    { path: '', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'login', component: LoginComponent },
    { path: 'login-with-token', component: LoginByTokenComponent },
    { path: 'sso', component: SsoComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'register-dependent', component: RegisterDependentComponent },
    { path: 'verify', component: VerifyComponent },
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: 'reset-password-confirm', component: ResetPasswordConfirmComponent },
    { path: 'my-account', component: MyAccountComponent,  canActivate: [AuthGuard]  },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
    {path: 'dependent', component: DependentComponent, canActivate: [AuthGuard]},
    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts